import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import * as _ from "lodash";
import APP_CONFIG from "../../app/app.config";

import * as $ from "jquery";
import VOICE_CODES from "../../constants/VOICE_CODES";
import SPEEDS from "../../constants/SPEEDS";
// import NUMBER_OF_NUMBERS from "../../constants/NUMBER_OF_NUMBERS";

declare let algorithm_level1: any;
declare let algorithm_level2: any;
declare let algorithm_level3: any;
declare let algorithm_level4: any;
declare let algorithm_level4_division: any;

declare let axios: any;

/*
  Generated class for the FisoMathProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class FisoMathProvider {
  constructor(public http: HttpClient) {
    console.log("Hello FisoMathProvider Provider");
  }

  /**
   * @param type: 0:basic,1:LB+,2:LB-,3:BB+,4:BB-
   * @param number: // 1 chu so, 2 chu so
   * @param row
   * @returns {*}
   */
  algorithm_level1(type, number, row) {
    return algorithm_level1(type, number, row);
  }

  /**
   *
   * @param number
   * @param row
   */
  algorithm_level2(number, row) {
    return algorithm_level2(number, row);
  }

  /**
   *
   * @param number
   * @param row
   */
  algorithm_level3(number, row) {
    return algorithm_level3(number, row);
  }

  /**
   *
   * @param number
   * @param row
   */
  algorithm_level3_so_am(number, row) {
    let numbers: any = this.algorithm_level3(number, row);
    let resultNumbers = [];

    _.forEach(numbers, (number, key) => {
      if (key % 2 !== 0) {
        resultNumbers.push(number);
        return;
      }

      const randNumber = Math.floor(Math.random() * 10);

      if (randNumber % 2 === 0) {
        number = number * -1;
      }

      resultNumbers.push(number);
    });

    return resultNumbers;
  }

  /**
   *
   * @param number
   * @param row
   * @param numberOfThapPhan
   */
  algorithm_level3_thap_phan(number, row, numberOfThapPhan) {
    let numbers: any = this.algorithm_level3(number, row);
    let resultNumbers = [];

    _.forEach(numbers, (number, key) => {
      if (key % 2 !== 0) {
        resultNumbers.push(number);
        return;
      }

      const randNumber = Math.floor(Math.random() * 100); // returns a random integer from 0 to 99

      number = number + randNumber / 100;
      number = number.toFixed(numberOfThapPhan);
      resultNumbers.push(number);
    });

    return resultNumbers;
  }

  /**
   *
   * @param number1
   * @param number2
   */
  algorithm_level4(number1, number2) {
    return algorithm_level4(number1, number2);
  }

  /**
   *
   * @param number1
   * @param number2
   */
  algorithm_level4_division(number1, number2) {
    return algorithm_level4_division(number1, number2);
  }

  guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

    return (
      s4() +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      s4() +
      s4()
    );
  }

  /**
   *
   * @param body
   */
  log(body) {
    return this.http.post(`${APP_CONFIG.baseURL}/post_log/add`, body);
  }

  /**
   *
   * @param body
   */
  parentLog(body) {
    body.post_type = "parent_log";
    return this.http.post(`${APP_CONFIG.baseURL}/posts/add`, body);
  }

  /**
   *
   * @param params
   */
  summary(params) {
    params = $.param(params);
    return this.http.get(`${APP_CONFIG.baseURL}/post_log/summary?${params}`);
  }

  /**
   *
   * @param params
   */
  summary_detail(params) {
    params = $.param(params);
    return this.http.get(
      `${APP_CONFIG.baseURL}/post_log/summary_detail?${params}`
    );
  }

  /**
   *
   */
  training_questions(params = {}) {
    params = $.param(params);
    return this.http.get(`${APP_CONFIG.baseURL}/posts/list?${params}`);
  }

  /**
   *
   */
  posts(params = {}) {
    params = $.param(params);
    return this.http.get(`${APP_CONFIG.baseURL}/posts/list?${params}`);
  }

  /**
   *
   */
  save_posts(body) {
    return this.http.post(`${APP_CONFIG.baseURL}/posts/add`, body);
  }

  getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
  }

  examlevels(level = "finger") {
    let levels = [
      {
        number_of_numbers: "1",
        number_of_rows: "4",
        timers: "6",
        // answer_timers: '6'
      },
      {
        number_of_numbers: "1",
        number_of_rows: "5",
        timers: "5",
        // answer_timers: '5'
      },
      {
        number_of_numbers: "1",
        number_of_rows: "6",
        timers: "6",
        // answer_timers: '6'
      },
      {
        number_of_numbers: "2",
        number_of_rows: "3",
        timers: "4",
        // answer_timers: '4'
      },
      {
        number_of_numbers: "2",
        number_of_rows: "3",
        timers: "3",
        // answer_timers: '3'
      },
      {
        number_of_numbers: "2",
        number_of_rows: "4",
        timers: "4",
        // answer_timers: '4'
      },
      {
        number_of_numbers: "2",
        number_of_rows: "5",
        timers: "4",
        // answer_timers: '4'
      },
      {
        number_of_numbers: "2",
        number_of_rows: "6",
        timers: "5",
        // answer_timers: '5'
      },
      {
        number_of_numbers: "2",
        number_of_rows: "8",
        timers: "7",
        // answer_timers: '7'
      },
      {
        number_of_numbers: "2",
        number_of_rows: "10",
        timers: "8",
        // answer_timers: '8'
      },
      {
        number_of_numbers: "3",
        number_of_rows: "4",
        timers: "4",
        // answer_timers: '4'
      },
      {
        number_of_numbers: "3",
        number_of_rows: "5",
        timers: "4",
        // answer_timers: '4'
      },
      {
        number_of_numbers: "3",
        number_of_rows: "6",
        timers: "4",
        // answer_timers: '4'
      },
      {
        number_of_numbers: "3",
        number_of_rows: "7",
        timers: "4",
        // answer_timers: '4'
      },
      {
        number_of_numbers: "3",
        number_of_rows: "8",
        timers: "4",
        // answer_timers: '4'
      },
      {
        number_of_numbers: "3",
        number_of_rows: "9",
        timers: "4",
        // answer_timers: '4'
      },
      {
        number_of_numbers: "3",
        number_of_rows: "10",
        timers: "4",
        // answer_timers: '4'
      },
      {
        number_of_numbers: "3",
        number_of_rows: "12",
        timers: "4",
        // answer_timers: '4'
      },
      {
        number_of_numbers: "3",
        number_of_rows: "15",
        timers: "4",
        // answer_timers: '4'
      },
      {
        number_of_numbers: "3",
        number_of_rows: "15",
        timers: "3",
        // answer_timers: '3'
      },
    ];

    if (level === "finger") {
      _.remove(levels, (o, k) => {
        return k >= 10;
      });
    }

    return levels;
  }

  async generateSound(strNumbers, number_of_numbers, number_of_rows, algorithm) {
    for (let voiceCode of VOICE_CODES) {
      for (let speed of SPEEDS) {
        const response = await axios({
          url: "https://vbee.vn/api/v1/tts",
          method: "POST",
          data: {
            voice_code: voiceCode.code,
            speed_rate: speed.code,
            input_text: strNumbers,
            app_id: "b985f6d5-489d-44f6-b8d2-2a65e0894d3f",
            callbackUrl: "https://example.com",
          },
          headers: {
            Authorization:
              "Bearer " +
              "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE2NTg0NjA2ODJ9.R8AWE0A1Ka967ZpicjBaD700JA1TGOG1noaT9d2_wwc",
          },
          timeout: 120000,
        });

        await this.downloadSound(response.data.result.request_id, {
          number_of_numbers,
          number_of_rows,
          voice_code: voiceCode.code,
          speed_rate: speed.code,
          input_text: strNumbers,
          algorithm: algorithm
        });
      }
    }
  }

  async downloadSound(requestId, newData: any = {}) {
    const response = await axios({
      url: "https://vbee.vn/api/v1/tts/" + requestId,
      method: "GET",
      headers: {
        Authorization:
          "Bearer " +
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE2NTg0NjA2ODJ9.R8AWE0A1Ka967ZpicjBaD700JA1TGOG1noaT9d2_wwc",
      },
      timeout: 120000,
    });

    if (response.data.result.audio_link) {
      newData.audio_link = response.data.result.audio_link;

      const resp = await axios({
        url: `${APP_CONFIG.baseURL}/upload/save_sound`,
        method: "POST",
        responseType: 'json',
        headers: {
          // Overwrite Axios's automatically set Content-Type
          'Content-Type': 'application/json'
        },
        data: newData,
        timeout: 120000,
      });

      console.log(`- Đã chạy xong dãy số:`, newData);

      return resp;
    }

    setTimeout(async () => await this.downloadSound(requestId, newData),6000);
  }
}



// WEBPACK FOOTER //
// ./src/providers/fiso-math/fiso-math.ts